export const statusHeight = 28;
export const statusPaddingY = 6;
export const statusPaddingX = 8;
export const statusBorderRadius = 16;
